import { render, staticRenderFns } from "./numOfBusiness.vue?vue&type=template&id=cfc148de&scoped=true&"
import script from "./numOfBusiness.vue?vue&type=script&lang=js&"
export * from "./numOfBusiness.vue?vue&type=script&lang=js&"
import style0 from "./numOfBusiness.vue?vue&type=style&index=0&id=cfc148de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc148de",
  null
  
)

export default component.exports